export default [
    {
        path: "/toolkit/instruction",
        name: "toolkit-instruction",
        component: () => import("@/views/toolkit/instruction.vue"),
    },
    {
        path: "/toolkit/imageprompt",
        name: "toolkit-imageprompt",
        component: () => import("@/views/toolkit/imageprompt.vue"),
    },
    {
        path: "/toolkit/prompt/act",
        name: "toolkit-prompt-act",
        component: () => import("@/views/toolkit/prompt/act.vue"),
    },
    {
        path: "/toolkit/stt/generate",
        name: "toolkit-stt-generate",
        component: () => import("@/views/toolkit/stt/generate.vue"),
    },
    {
        path: "/toolkit/stt/list",
        name: "toolkit-stt-list",
        component: () => import("@/views/toolkit/stt/list.vue"),
    },
    {
        path: "/toolkit/tts/generate",
        name: "toolkit-tts-generate",
        component: () => import("@/views/toolkit/tts/generate.vue"),
    },
    {
        path: "/toolkit/tts/list",
        name: "toolkit-tts-list",
        component: () => import("@/views/toolkit/tts/list.vue"),
    },
    {
        path: "/toolkit/test",
        name: "toolkit-test",
        component: () => import("@/views/toolkit/test.vue"),
    },
]